
import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import Icon from "@/components/UI/Icon.vue";
import SearchInput from "@/components/Reusable/CustomInputs/SearchInput.vue";
import Fuse from "fuse.js";
import { DesignSetPost } from "@/types/design-library";
import AlertBox from "@/components/Reusable/CustomInputs/AlertBox.vue";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import { capitalize } from "lodash";

@Component({
  components: { DropdownInput, AlertBox, SearchInput, Icon }
})
export default class DesignLibrarySidebar extends Vue {
  @Prop({
    default() {
      return [];
    }
  })
  items!: DesignSetPost[];

  searchQuery = "";
  selectedType = "";

  @Watch("items")
  onItemsChange() {
    this.searchQuery = "";
    this.selectedType = "";
  }

  get filteredItems() {
    const search = this.searchQuery;

    if (!search) return this.items.filter(this.filterItemByType);

    const fuse = new Fuse(this.items, {
      keys: ["name"],
      threshold: 0.2
    });

    return fuse
      .search(search.trim())
      .map(r => r.item)
      .filter(this.filterItemByType);
  }

  get types() {
    const uniqueTypes = [...new Set(this.items.map(item => item.type))].filter(
      Boolean
    );

    return uniqueTypes.map(type => ({
      value: type,
      text: capitalize(type?.replace("breakdance_", ""))
    }));
  }

  get treeItems() {
    const orphans: DesignSetPost[] = [];

    const groupedByTags = this.filteredItems.reduce((r, a) => {
      if (!a.tags.length) {
        orphans.push(a);
      } else {
        a.tags.forEach(tag => {
          r[tag] = r[tag] || [];
          r[tag].push(a);
        });
      }

      return r;
    }, Object.create(null));

    const tags = Object.keys(groupedByTags).map(key => {
      return {
        id: key,
        name: key,
        children: groupedByTags[key]
      };
    });

    return [...orphans, ...tags];
  }

  filterItemByType(item: DesignSetPost) {
    if (this.selectedType) {
      return item.type === this.selectedType;
    }
    return true;
  }
}
